/**
 * Reducer to handle theme selection in send, gift, and reveal flows
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../utils/serverProps'

function getInitialState(props = serverProps) {
  const { themeId = '', activeThemeIds = [], themeSpecs = {} } = props

  const themeList = activeThemeIds
    .filter(id => themeSpecs[id]) // corresponding entries in themeSpecs
    .map(id => ({ ...themeSpecs[id], id })) // create array of theme objects
    .slice(0, 6) // don't show more than 6 themes

  const initialState = {
    themeId,
    themeSpecs,
    themeList,
  }

  return initialState
}

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case types.EXTERNAL.RECEIVED_DATA:
      return getInitialState(action.data)

    case types.THEME.CHANGE_THEME_ID:
      return {
        ...state,
        themeId: action.data.themeId,
      }

    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
    case types.TRANSACTION.CANCELLED_TRANSACTION:
      return {
        ...state,
        themeId: '',
      }

    default:
      return state
  }
}
